import HopeShiftPage from './HopeShiftPage';

export default HopeShiftPage;
